"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteTableMiddleMore = exports.QuoteTableMiddle = void 0;
var react_1 = __importDefault(require("react"));
var custom_table_1 = require("./custom_table");
var config_1 = require("../../modules/quote/config");
var swr_1 = __importDefault(require("swr"));
var quote_1 = require("../../modules/quote");
var addzxgbtn_1 = require("../page/shared/zxg/addzxgbtn");
var xglinks_1 = require("./xglinks");
var qa_tip_1 = require("../page/shared/qa_tip");
/**
 * 行情中表格
 * @returns
 */
function QuoteTableMiddle(props) {
    var _a;
    var tableitemconfig = custom_table_1.custom_table[props.table_key]; //表格显示配置
    var xgtype = (_a = props.xgtype) !== null && _a !== void 0 ? _a : '';
    //行情字段
    var quoteitemlist = tableitemconfig.filter(function (v) {
        return typeof v.value == 'number';
    }).map(function (v) { return v.value; });
    var _b = (0, swr_1.default)("quotesmalltable_".concat(props.fs, "_").concat(props.quotecode, "_").concat(props.table_key, "_").concat(props.order, "_").concat(props.orderdur), function () { return (0, quote_1.getListQuoteOrFS)({
        fs: props.fs,
        quotecode_list: props.quotecode,
        itemlist: quoteitemlist,
        fid: props.order,
        po: props.orderdur,
        pz: props.count,
        pn: 1,
    }); }, {
        refreshInterval: 60 * 1000,
        dedupingInterval: 59 * 1000
    }), data = _b.data, error = _b.error;
    if (data) {
        return (react_1.default.createElement("table", { className: "quotetable_m" },
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null, tableitemconfig.filter(function (v) { return v.hide != true; }).map(function (v, index) {
                    return react_1.default.createElement("th", { key: index, dangerouslySetInnerHTML: { __html: v.title } });
                }))),
            react_1.default.createElement("tbody", null, data.map(function (v, index) {
                return react_1.default.createElement("tr", { key: index }, tableitemconfig.filter(function (v) { return v.hide != true; }).map(function (v2, index2) {
                    var v2_td_value = react_1.default.createElement(react_1.default.Fragment, null);
                    if (typeof v2.value == 'number') {
                        v2_td_value = v[v2.value].html;
                        if (v[v2.value].source == '欧洲斯托克50') {
                            v2_td_value = react_1.default.createElement(react_1.default.Fragment, null,
                                v[v2.value].html,
                                react_1.default.createElement(qa_tip_1.TitleTip, { txt: "\u6B27\u6D32\u65AF\u6258\u514B50\u6307\u6570\uFF08Euro Stoxx 50\uFF09\u662F\u5FB7\u610F\u5FD7\u4EA4\u6613\u6240\u96C6\u56E2\u65D7\u4E0B\u6307\u6570\u63D0\u4F9B\u5546\u65AF\u6258\u514B\u8BBE\u8BA1\u7684\u6B27\u5143\u533A\u80A1\u7968\u7684\u80A1\u7968\u6307\u6570\u3002\u5B83\u662F\u7531\u6B27\u76DF\u6210\u5458\u56FD\u6CD5\u56FD\u3001\u5FB7\u56FD\u7B4912\u56FD\u8D44\u672C\u5E02\u573A\u4E0A\u5E02\u768450\u53EA\u8D85\u7EA7\u84DD\u7B79\u80A1\u7EC4\u6210\u7684\u5E02\u503C\u52A0\u6743\u5E73\u5747\u6307\u6570\u3002" }));
                        }
                    }
                    return (react_1.default.createElement("td", { key: index2, className: (v2 === null || v2 === void 0 ? void 0 : v2.tdclass) || "" },
                        v2.value == 'rank' &&
                            react_1.default.createElement(react_1.default.Fragment, null, index + 1),
                        v2.value == 'xglinks' &&
                            react_1.default.createElement(xglinks_1.XGLinks, { quotecode: v[config_1.QuoteItem.行情统一链接].source, xgtype: xgtype }),
                        // typeof v2.value == 'number' && v[v2.value].html
                        typeof v2.value == 'number' && v2_td_value,
                        v2.value == 'gbalink' && v[config_1.QuoteItem.H股对应的A股代码] &&
                            react_1.default.createElement(xglinks_1.XGLinkGB, { code: v[config_1.QuoteItem.H股对应的A股代码].txt }),
                        v2.value == 'gbhklink' && v[config_1.QuoteItem.代码带链接] &&
                            react_1.default.createElement(xglinks_1.XGLinkGBHK, { code: v[config_1.QuoteItem.代码带链接].txt }),
                        v2.value == 'gb_hka_link' && v[config_1.QuoteItem.H股对应的A股代码] &&
                            react_1.default.createElement(xglinks_1.AHXGLinkGB, { code: v[config_1.QuoteItem.H股对应的A股代码].txt }),
                        v2.value == 'astock_xg_link' && v[config_1.QuoteItem.代码带链接] &&
                            react_1.default.createElement(xglinks_1.XGLinkAStock, { code: v[config_1.QuoteItem.代码带链接].txt }),
                        v2.value == 'jjetflink' && v[config_1.QuoteItem.代码带链接] &&
                            react_1.default.createElement(xglinks_1.XGLinkJJ, { code: v[config_1.QuoteItem.代码带链接].txt }),
                        v2.value == 'addzxg' &&
                            react_1.default.createElement(addzxgbtn_1.AddZXGBtn, { quotecode: v[config_1.QuoteItem.行情统一链接].source }),
                        v2.value == 'addzxghk' && v[config_1.QuoteItem.代码带链接] &&
                            react_1.default.createElement(addzxgbtn_1.AddZXGBtn, { quotecode: v[config_1.QuoteItem.代码带链接].source })));
                }));
            }))));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null));
}
exports.QuoteTableMiddle = QuoteTableMiddle;
function QuoteTableMiddleMore(props) {
    return (react_1.default.createElement("div", { className: "qtmmore" }, props.children));
}
exports.QuoteTableMiddleMore = QuoteTableMiddleMore;
